import React from 'react';
import { StyleSheet, View } from 'react-native';

/**
 * A component which reproduces CSS3 `display: list-item;` behavior. It
 * prepends its child with a marker box containing a marker string
 * representation for this child index.
 *
 * See {@link https://www.w3.org/TR/css-lists-3/#markers | CSS Lists and Counters Module Level 3, Markers}.
 *
 * @public
 */
export default function MarkedListItem(_ref) {
  var counterRenderer = _ref.counterRenderer,
    index = _ref.index,
    startIndex = _ref.startIndex,
    rtlLineReversed = _ref.rtlLineReversed,
    rtlMarkerReversed = _ref.rtlMarkerReversed,
    markerTextStyle = _ref.markerTextStyle,
    markerBoxStyle = _ref.markerBoxStyle,
    maxNumOfCodepoints = _ref.maxNumOfCodepoints,
    markerTextWidth = _ref.markerTextWidth,
    style = _ref.style,
    renderMarker = _ref.renderMarker,
    enableMarkerClipping = _ref.enableMarkerClipping,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(View, {
    testID: "marked-list-item",
    style: [rtlLineReversed ? styles.lineRtl : styles.lineLtr, style],
    key: index
  }, renderMarker({
    counterRenderer: counterRenderer,
    rtlMarkerReversed: typeof rtlMarkerReversed === 'boolean' ? rtlMarkerReversed : true,
    counterIndex: index + startIndex,
    maxNumOfCodepoints: maxNumOfCodepoints,
    style: markerBoxStyle,
    markerTextStyle: markerTextStyle,
    markerTextWidth: markerTextWidth,
    enableMarkerClipping: enableMarkerClipping
  }), children);
}
var styles = StyleSheet.create({
  lineLtr: {
    flexWrap: 'nowrap',
    alignSelf: 'stretch',
    flexDirection: 'row'
  },
  lineRtl: {
    flexWrap: 'nowrap',
    alignSelf: 'stretch',
    flexDirection: 'row-reverse'
  }
});